import api from "../httpClient"
import type { LifeScoresReport } from "../../types"

const getReport = async (params: { cohort_id: string; user_id?: string | number }) => {
  const resp = await api.get<LifeScoresReport>("/api/reports/life-scores/", { params })
  return resp.data
}

export const lifeScores = {
  getReport,
}
